import React, { useEffect, useState, useMemo, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { debounce } from "lodash";
import { Table, Input, Button, Modal, Tooltip } from "antd";
import moment from "moment";

import { errEnum, PAGE_LENGTH } from "../../config";
import copy from "../../assets/images/webToLead/copy.png";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import emailSync from "../../assets/images/email-setup/email-sync.svg";
import subscribepopupImg from "../../assets/images/subscribe-now-executive-prompt-img.jpg";
import TrialModal from "../../common/TrialModal";
import { subscriptionContentInfo } from "../../config";
import {
  getExecutiveEmployeeList,
  savePaginationValues,
  saveAdvancedSelectedFilters,
  selectedRow,
  saveSearchAction,
  resetExecutiveSavedSearch,
  emptyErrorObj,
  getExecutiveTagList,
} from "../../actionCreator/executiveListingActionCreater";
import {
  submitLead,
  getEmployeeViewableStatusUpdate,
} from "../../actionCreator/executiveDetailsActionCreator";
import Loader from "../loader";
import {
  getUserInfo,
  getSubscriptionUserInfo,
  getPartialPhoneNumber,
} from "../../utils/utils";
import { useExport } from "./hooks/useExport";
import { colorArray } from "../../constant/profileBgcolors";
import TagExecutive from "./TagExecutive";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";
import EmailForm from "../../common/EmailForm";
import SubscriptionModal from "../web2lead/SubscriptionModal";
import FeatureComingSoon from "../../common/FeatureComingSoon";

const ExecutiveContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onExport } = useExport();
  const { showAlert } = useAlert();
  const { id: accountId, validTo } = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(validTo);
  const isExpired = validToDate.isBefore(currentDate);
  const { isAuthenticated: isLoggedIn, isEmailSetupView } =
    useContext(AuthContext);
  const { Search } = Input;
  const [showEmail, setShowEmail] = useState({});
  const [showPhone, setShowPhone] = useState({});
  const [saveExecutiveSearchSuccess, setSaveExecutiveSearchSuccess] =
    useState(false);
  const [employeeIdsData, setEmployeeIdsData] = useState([]);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const [subModal, setSubModal] = useState(false);
  const [executiveEmployeeList, setExecutiveEmployeeList] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showTagModal, setShowTagModal] = useState(false);
  const [searchValues, setSearchValues] = useState({
    tagname: "",
    description: "",
    tagError: "",
  });
  const [successMsg, setSuccessMsg] = useState("");

  const getLeadsData = useSelector(
    (state) => state.executiveDetailsReducer?.getExecutiveLead
  );
  const getEmployeeViewableData = useSelector(
    (state) => state.executiveDetailsReducer?.executiveEmployeeViewableStatus
  );
  const saveSearchData = useSelector(
    (state) => state.executiveListingReducer?.saveSearch
  );
  const errObj = useSelector((state) => state.executiveListingReducer.errObj);
  const companyFilterList = useSelector(
    (state) => state.executiveListingReducer
  );
  const companySelectedFilterList = useSelector(
    (state) => state.executiveListingReducer.selectedFilters
  );
  const loading = useSelector((state) => state.CommonReducer.loading);
  const paginationValue = useSelector(
    (state) => state.executiveListingReducer.paginationValue
  );
  const selectedRecords = useSelector(
    (state) => state.executiveListingReducer.selectedRecords
  );

  const topSearchValue = useSelector(
    (state) => state.HeaderReducer.topSearchValue
  );
  const dashboardExecutiveSavedSearchData = useSelector(
    (state) => state.DashboardReducer.executiveSavedSearchData
  );
  const executiveSelectionList = useSelector(
    (state) => state.executiveListingReducer?.executiveSelectionList
  );

  const updateEmailStatus = (showEmail, row) => {
    if (!accountId || isExpired) {
      setSubModal(true);
    } else {
      setShowEmail({ ...showEmail, [row.key]: true });
      dispatch(getEmployeeViewableStatusUpdate("Email", row));
    }
  };
  const updatePhoneStatus = (showPhone, row) => {
    setShowPhone({ ...showPhone, [row.key]: true });
    dispatch(getEmployeeViewableStatusUpdate("Mobile", row));
  };

  const openInfoModel = () => {
    setOpenModal({ info: null, open: !isLoggedIn || !accountId });
  };

  const postLeads = async (record, isLeadSubmit) => {
    const { id } = getUserInfo();
    let leadPayload = {
      accountId: accountId,
      firstname: record.firstname,
      lastname: record.lastname,
      fullname: record.fullname,
      title: record.title,
      client: record.client,
      emailId: record.emailId,
      phoneNo: record.phoneNo,
      bio: record.bio,
      description: record.description,
      userId: id,
      employeeId: record.id,
      address: record?.company?.address,
      companyId: record?.company?.id,
      companyName: record?.company?.name,
      industryId: record?.company?.industry?.id,
      industryText: record?.company?.industry?.name,
      empSizeId: record?.company?.range?.name,
      city: record?.company?.city,
      state: record?.company?.state,
      country: record?.company?.country,
      status: 11,
    };
    //status 11 for new lead
    if (!isLeadSubmit) {
      const res = await dispatch(submitLead(leadPayload, employeeIdsData));
      const isLimitExceed = res?.response?.data?.title
        ?.toLowerCase()
        ?.includes("subscriber ussage limnit expired");
      if (isLimitExceed) {
        showAlert(
          "error",
          "Your subscription has expired. Please renew your subscription to continue using the service."
        );
      }
    } else {
      navigate("/lead-details/" + isLeadSubmit);
    }
  };

  const isLeadsSubmitted = (selEmployeeId) => {
    const filteredData = getLeadsData.filter((item) => {
      return item.employeeId == selEmployeeId.id;
    });
    if (filteredData?.length > 0) {
      return filteredData[0].id;
    } else {
      return 0;
    }
  };

  useEffect(() => {
    if (companySelectedFilterList?.quickSelectionRange?.start) {
      let selectionKeys = [];
      executiveSelectionList?.forEach((record) => {
        selectionKeys.push(record);
      });
      dispatch(selectedRow(selectionKeys));
    } else {
      dispatch(selectedRow([]));
    }
  }, [executiveSelectionList]);

  useMemo(() => {
    const payload = {
      ...companySelectedFilterList,
      topSearchValue: topSearchValue,
    };
    dispatch(saveAdvancedSelectedFilters(payload));
    if (topSearchValue) {
      dispatch(getExecutiveEmployeeList(payload, paginationValue, true));
    }
  }, [topSearchValue]);

  const renderSocialLinks = (socialLinks) => {
    return socialLinks?.map((link) => {
      if (link?.name === "facebook") {
        return (
          <Link to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20 facebook lab la-facebook"></i>
          </Link>
        );
      } else if (link?.name === "Linkedin") {
        return (
          <Link to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20 linkedin  lab la-linkedin"></i>
          </Link>
        );
      } else if (link?.name === "twitter") {
        return (
          <Link to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20  twitter la la-twitter-square"></i>
          </Link>
        );
      }
    });
  };

  useEffect(() => {
    let data = [];
    let empIdsArr = [];
    companyFilterList?.executiveEmployeeList?.forEach((record) => {
      empIdsArr = [...empIdsArr, record.id];
      data = [
        ...data,
        {
          key: record.id,
          id: record.id,
          executiveData: record,
          name: record,
          company: record?.company?.name,
          location: `${record?.city ? record?.city + "," : ""} ${
            record?.state ? record?.state : ""
          }`,
          email: record?.emailId,
          phone: record?.company?.phoneNo,
          mobile: record.phoneNo,
          designation: record?.title,
          social: renderSocialLinks(record?.socialLinks),
          isdownloadedEmail: record?.isdownloadedEmail,
          isdownloadedMobile: record?.isdownloadedMobile,
          directDial: record,
        },
      ];
    });

    setExecutiveEmployeeList(data);
    setEmployeeIdsData(empIdsArr);
  }, [companyFilterList]);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      if (!selected) {
        const filteredRecords = selectedRecords?.filter(
          (d) => d !== record.key
        );
        dispatch(selectedRow(filteredRecords));
      } else {
        dispatch(selectedRow([...selectedRecords, record.key]));
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const keys = changeRows?.map((d) => d.key);
      if (!selected) {
        const filteredRecords = selectedRecords?.filter(
          (d) => !keys.includes(d)
        );
        dispatch(selectedRow(filteredRecords));
      } else {
        dispatch(selectedRow([...selectedRecords, ...keys]));
      }
    },
    getCheckboxProps: (record) => {
      return {
        disabled: record.name === "Disabled User", // Column configuration not to be checked
        name: record.name,
      };
    },
    selectedRowKeys: selectedRecords,
  };

  const checkLoginStatus = () => {
    if (isLoggedIn) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  };

  const onSearch = debounce((event) => {
    const payload = {
      ...companySelectedFilterList,
      searchKeyword: event?.target?.value,
    };
    const pageValues = {
      start: 0,
      end: PAGE_LENGTH,
    };
    dispatch(savePaginationValues(pageValues));
    dispatch(saveAdvancedSelectedFilters(payload));
    dispatch(getExecutiveEmployeeList(payload, pageValues));
  }, 500);

  const onPageChange = (page, pageSize) => {
    checkLoginStatus();
    if (!isLoggedIn) {
      if (page > 1 || pageSize > PAGE_LENGTH)
        setOpenModal({ info: null, open: true });
      setShowModal(false);
      return false;
    } else {
      const pageValues = {
        start: page - 1,
        end: pageSize,
      };
      let payload = {
        ...companySelectedFilterList,
        pageSize,
      };
      if (topSearchValue) {
        payload = {
          ...payload,
          topSearchValue: topSearchValue,
        };
      }
      dispatch(saveAdvancedSelectedFilters(payload));
      //in case of saved search in reducer it will discard other filters
      //searchPayload = JSON.parse(newList[0].dataDump);
      dispatch(savePaginationValues(pageValues));
      let searchPayload = {};
      if (Object.keys(companySelectedFilterList?.selectedSavedSearch).length) {
        searchPayload = JSON.parse(
          companySelectedFilterList?.selectedSavedSearch[0]?.dataDump
        );
        dispatch(getExecutiveEmployeeList(searchPayload, pageValues));
      } else {
        dispatch(getExecutiveEmployeeList(payload, pageValues));
      }
    }
  };

  const getDetails = (id, name) => {
    let cname = name.replaceAll(" ", "-", name);
    navigate(`/executive-details/${id}/${cname}`);
  };

  const onHandleSaveSearch = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      setShowModal(true);
    }
  };

  const checkFilters = () => {
    let hasFilters = true;

    Object.keys(companySelectedFilterList).forEach((item) => {
      if (companySelectedFilterList[item]?.length) {
        hasFilters = false;
      }
    });
    return hasFilters;
  };

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
  };

  const onConfrim = () => {
    if (!searchValues.tagname) {
      setSearchValues({
        ...searchValues,
        tagError: "error",
      });
    } else {
      const { id, email, login } = getUserInfo();
      const payload = {
        accountId: login,
        dataDump: JSON.stringify(companySelectedFilterList),
        fullName: searchValues.tagname,
        emailId: email,
        source: "Executive",
        userId: id,
      };
      dispatch(saveSearchAction(payload));
      setShowModal(false);
    }
  };

  const onInputChange = (e) => {
    setSearchValues({
      ...searchValues,
      [e.target.name]: e.target.value,
    });
  };

  const redirectToSignup = () => {
    setShowModal(false);
    setOpenModal(false);
    navigate("/signup");
  };

  const tagPage = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      if (selectedRecords.length) {
        setShowTagModal(true);
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const printPage = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      window.print();
    }
  };

  const closeTagModal = () => {
    setShowTagModal(false);
  };

  const copyToClipboard = (text) => {
    if (window.clipboardData && window.clipboardData.setData) {
      // IE: prevent textarea being shown while dialog is visible
      return window.clipboardData.setData("Text", text);
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported("copy")
    ) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      // Prevent scrolling to bottom of page in MS Edge
      textarea.style.position = "fixed";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        // Security exception may be thrown by some browsers
        return document.execCommand("copy");
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  };

  const closeExecutiveSuccessModal = () => {
    setSaveExecutiveSearchSuccess(false);
    dispatch(resetExecutiveSavedSearch());
  };

  useEffect(() => {
    if (Object.keys(saveSearchData).length) {
      setSaveExecutiveSearchSuccess(true);
      setSuccessMsg("Saved Search Created!");
    }
  }, [saveSearchData]);

  const columns = [
    {
      title: <div className="companyname">Executive Name</div>,
      dataIndex: "name",
      fixed: "left",
      render: (record, row, index) => {
        return (
          <div
            className="namecol"
            onClick={() => getDetails(row.key, record?.fullname)}
          >
            <div
              className="logo"
              style={{
                textTransform: "uppercase",
                backgroundColor: colorArray[index],
              }}
            >
              {record?.firstname?.[0]}
              {record?.lastname?.[0]}
            </div>
            <span className="cname">
              {/* {record?.fullname} */}
              {record?.fullname
                ? record.fullname
                : record.firstname + " " + record.lastname}
            </span>
          </div>
        );
      },
    },
    {
      title: "Company",
      dataIndex: "company",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "email",
      width: 180,
      render: (text, row) => {
        return isLoggedIn ? (
          <>
            <div
              className={`d-flex align-items-center ${showEmail[row.key] && row.key === getEmployeeViewableData?.id && "justify-content-between"}`}
              style={{ gap: 10 }}
            >
              {showEmail[row.key] && row.key === getEmployeeViewableData?.id ? (
                <>
                  <Tooltip title={getEmployeeViewableData?.emailId}>
                    <span>
                      {getEmployeeViewableData?.emailId?.length > 12
                        ? `${getEmployeeViewableData?.emailId.substring(0, 10)}...`
                        : getEmployeeViewableData?.emailId}
                    </span>
                  </Tooltip>
                  <div className="email-grp-btn" style={{ padding: "0 3px" }}>
                    <Tooltip title="copied" trigger="click">
                      <img
                        src={copy}
                        alt=""
                        style={{
                          height: "25px",
                          width: "25px",
                          padding: "5px",
                          maxWidth: "25px",
                        }}
                        className="cursor-pointer"
                        onClick={() =>
                          copyToClipboard(getEmployeeViewableData?.emailId)
                        }
                      />
                    </Tooltip>
                    {isEmailSetupView && (
                      <EmailForm
                        recipientEmail={getEmployeeViewableData?.emailId}
                        empId={getEmployeeViewableData?.id}
                      >
                        <img
                          src={emailSync}
                          alt=""
                          style={{
                            borderLeft: "0.20000000298023224px solid #707070",
                            height: "25px",
                            width: "25px",
                            padding: "5px",
                          }}
                          className="cursor-pointer"
                        />
                      </EmailForm>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <span
                    className="white-space-nowrap cursor-pointer"
                    onClick={() => updateEmailStatus(showEmail, row)}
                  >
                    View Email{" "}
                  </span>
                  <div
                    className={
                      row?.isdownloadedEmail
                        ? " btn iconemail emails-open"
                        : " btn iconemail emails"
                    }
                    onClick={() => updateEmailStatus(showEmail, row)}
                  ></div>
                </>
              )}
            </div>
          </>
        ) : (
          <div
            className="  btn iconemail emails"
            onClick={() => openInfoModel()}
          ></div>
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      className: "phone",
      render: (text, row) => {
        return getPartialPhoneNumber(text);
      },
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      render: (record, row) => {
        return isLoggedIn ? (
          <>
            <span
              className={
                row?.isdownloadedMobile ? " btn mobile-open" : " btn mobile"
              }
              onClick={() => updatePhoneStatus(showPhone, row)}
            ></span>
            {showPhone[row.key] && row.key === getEmployeeViewableData?.id && (
              <>
                <span className="phoneValue fs-12 pl-1">
                  {getEmployeeViewableData?.phoneNo}
                </span>
                <span
                  title="copy phone"
                  className="  fs-17 btn  la  la-copy text-black"
                  onClick={() =>
                    copyToClipboard(getEmployeeViewableData?.phoneNo)
                  }
                ></span>
              </>
            )}
          </>
        ) : (
          <span className=" btn mobile" onClick={() => openInfoModel()}></span>
        );
      },
    },
    {
      title: "Social",
      dataIndex: "social",
    },
    {
      title: "",
      dataIndex: "name",
      render: (record, row) => {
        let checkLeadSubmitted = isLeadsSubmitted(record);

        return isLoggedIn && accountId ? (
          <Button
            style={{ height: "auto" }}
            className="keyexebtn d-none d-sm-inline-block small"
            // className="keyexebtn d-none d-sm-inline-block small btn btn-primary-added-lead text-black"
            // loading={
            //   !Object.keys(submitLeadRes).length && addToLeads === record.id
            //     ? true
            //     : false
            // }
            onClick={() => postLeads(record, checkLeadSubmitted)}
          >
            {checkLeadSubmitted ? (
              <span className="btn btn-primary-add-lead-green text-black">
                <i className="las la-check-double fs-12 pr-1"></i>LEAD ADDED
              </span>
            ) : (
              <span className="btn btn-primary-add-lead-gray text-black">
                <i className="las la-user-plus fs-12 pr-1"></i>ADD TO LEADS
              </span>
            )}
          </Button>
        ) : (
          <Button
            style={{ height: "auto" }}
            className="keyexebtn d-none d-sm-inline-block small"
            onClick={() => openInfoModel()}
          >
            <span className="btn btn-primary-add-lead-gray text-black">
              <i className="las la-user-plus  fs-12  pr-1"></i>ADD TO LEADS
            </span>
          </Button>
        );
      },
    },
  ];

  const currentPage = paginationValue.start + 1;
  const itemsPerPage = paginationValue.end;
  const totalItems = companyFilterList?.totalExecutiveCount;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <SubscriptionModal
        isOpen={subModal}
        handleCancel={() => setSubModal(false)}
      />
      <div id="content-wrapper" className="d-flex flex-column ">
        <div id="content" className="shadow">
          <div className="container-fluid pl-0 pr-0">
            <div className="row">
              <div className="col-xl-12 col-lg-10 pl-0">
                <div className="card shadow mb-4">
                  <div className="card-header py-3 f-rev d-flex align-items-center justify-content-between">
                    <div
                      className="d-flex align-items-lg-center m-0 ml-2 font-weight-bold text-primary mob-t"
                      style={{ gap: 10, width: "100%" }}
                    >
                      {totalItems > 0 && (
                        <h6 className="m-0 ml-2 font-weight-bold text-primary mob-t">
                          Showing {startItem}-{endItem}
                          <span className="m-1">of</span>{" "}
                          {companyFilterList?.totalExecutiveCount}
                          <span className="m-1">results</span>
                        </h6>
                      )}
                      <span className="heading12px">
                        {companySelectedFilterList?.quickSelectionRange && (
                          <>
                            Pages:{" "}
                            {
                              companySelectedFilterList?.quickSelectionRange
                                ?.start
                            }
                            -
                            {
                              companySelectedFilterList?.quickSelectionRange
                                ?.end
                            }
                            ;{" "}
                          </>
                        )}
                        {!!selectedRecords?.length && (
                          <span className="heading12px">
                            {selectedRecords?.length} records selected
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="buttons-container textsearch">
                      <ul className="d-flex mt-1  m-mt">
                        <li>
                          <a
                            className=" mr-2"
                            href="#"
                            id=""
                            role="button"
                            data-toggle=""
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i
                              className="right-icons las la-tags"
                              aria-hidden="true"
                              onClick={tagPage}
                            ></i>
                          </a>
                        </li>

                        <li>
                          <a
                            className=" mr-2"
                            href="#"
                            id=""
                            role="button"
                            data-toggle=""
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i
                              className="right-icons la la-file-excel"
                              aria-hidden="true"
                              onClick={() => {
                                checkLoginStatus();
                                onExport(selectedRecords, "exl");
                              }}
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            className=" mr-2"
                            role="button"
                            data-toggle=""
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={() => {
                              checkLoginStatus();
                              onExport(selectedRecords, "pdf");
                            }}
                          >
                            <i
                              className="right-icons la la-file-pdf"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li>
                          <a
                            className=" mr-2"
                            role="button"
                            data-toggle=""
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={printPage}
                          >
                            <i
                              className="right-icons la la-print"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                      </ul>
                      <Search
                        placeholder="Search By Designation"
                        allowClear
                        onChange={onSearch}
                        style={{ width: 200 }}
                      />

                      <Button
                        className="d-none d-sm-inline-block ml-2 btn-outline-grey"
                        onClick={onHandleSaveSearch}
                        disabled={checkFilters()}
                        title={checkFilters() ? "Filters are not selected" : ""}
                      >
                        <i className="fas fa-save pr-1"></i> SAVE SEARCH
                      </Button>
                      <FeatureComingSoon>
                        <Button className="d-none d-sm-inline-block ml-2 btn-outline-grey">
                          <i className="fas fa-bolt pr-1"></i> CONNECT TO CRM
                        </Button>
                      </FeatureComingSoon>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-container text-nowrap">
                      <div className="table-wrapper">
                        {!loading ? (
                          <Table
                            rowSelection={{
                              type: "checkbox",
                              ...rowSelection,
                            }}
                            columns={columns}
                            dataSource={executiveEmployeeList}
                            pagination={{
                              responsive: true,
                              defaultCurrent: paginationValue?.start + 1,
                              current: paginationValue?.start + 1,
                              total: companyFilterList?.totalExecutiveCount,
                              pageSize:
                                parseInt(PAGE_LENGTH) >
                                parseInt(companyFilterList?.totalExecutiveCount)
                                  ? companyFilterList?.totalExecutiveCount
                                  : paginationValue.end
                                    ? paginationValue.end
                                    : PAGE_LENGTH,
                              position: ["bottomCenter"],
                              onChange: onPageChange,
                            }}
                          />
                        ) : (
                          <Loader />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {saveExecutiveSearchSuccess ? (
        <Modal
          title=""
          width={"400px"}
          closable={true}
          open={saveExecutiveSearchSuccess}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={closeExecutiveSuccessModal}
            >
              OK
            </Button>,
          ]}
        >
          <div className="pop-up errorformcontainer ">
            <p>{successMsg}</p>
          </div>
        </Modal>
      ) : (
        ""
      )}
      <TagExecutive
        selectedRecords={selectedRecords}
        showTagModal={showTagModal && isLoggedIn}
        closeTagModal={closeTagModal}
        callback={(userId) => dispatch(getExecutiveTagList(userId))}
      />

      {showModal ? (
        isLoggedIn ? (
          <Modal
            title="Save Search"
            width={"400px"}
            closable={true}
            open={showModal}
            onCancel={closeModal}
            onOk={onConfrim}
          >
            <div className="pop-up errorformcontainer ">
              <div className="form">
                <div className="formcol1">
                  <label>Search Name</label>
                </div>
                <div className="formcol2">
                  <Input
                    name="tagname"
                    status={searchValues?.tagError}
                    value={searchValues.tagname}
                    placeholder="Name"
                    onChange={onInputChange}
                  />
                </div>
              </div>
            </div>
          </Modal>
        ) : (
          <TrialModal
            openModal={showModal}
            closeModal={closeModal}
            redirectToSignup={redirectToSignup}
            buttonText="Start Free Trial"
            redirect={true}
            modalBody={
              <div id="small-dialog2">
                <div align="center">
                  <img src={popupImg} alt="" />
                </div>
                <p style={{ color: "#0000FF" }}>
                  Get 10 free verified contacts with a BeyondLeadz Pro trial
                </p>
                <p>
                  BeyondLeadz Pro customers close deals faster thanks to
                  relevant
                </p>
              </div>
            }
            modalWidth="400px"
          />
        )
      ) : (
        ""
      )}

      {errObj[errEnum.EXECUTIVE_DOWNLOAD_ERROR] && (
        <TrialModal
          openModal={!!errObj[errEnum.EXECUTIVE_DOWNLOAD_ERROR]}
          closeModal={() => dispatch(emptyErrorObj())}
          buttonText="OK"
          modalBody={
            <div id="small-dialog2">
              {errObj[errEnum.EXECUTIVE_DOWNLOAD_ERROR]
                ? errObj[errEnum.EXECUTIVE_DOWNLOAD_ERROR].message
                : "Unable to complete the action. Please try again later."}
            </div>
          }
          modalWidth="400px"
        />
      )}

      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText={subscriptionContentInfo.btntext}
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={subscribepopupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                {subscriptionContentInfo.content}
              </p>
            </div>
          }
          modalWidth="400px"
        />
      )}
    </>
  );
};

export default ExecutiveContent;
